/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class OperationsFeatureFlagsWithDefaults extends models.FeatureFlagsWithDefaults {
    getFixupPrototypeFunction() { return OperationsFeatureFlagsWithDefaults.fixupPrototype; }

    static newInstance(model: Partial<OperationsFeatureFlagsWithDefaults>): OperationsFeatureFlagsWithDefaults {
        let obj = Object.assign(new OperationsFeatureFlagsWithDefaults(), model);
        OperationsFeatureFlagsWithDefaults.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<OperationsFeatureFlagsWithDefaults>): OperationsFeatureFlagsWithDefaults {
        if (!model) return null;
        return OperationsFeatureFlagsWithDefaults.newInstance(<OperationsFeatureFlagsWithDefaults> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: OperationsFeatureFlagsWithDefaults) {
        if (!obj) return;

        models.OperationsFeatureFlagsWithDefaults.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: OperationsFeatureFlagsWithDefaults): boolean {
        if (models.FeatureFlagsWithDefaults.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, OperationsFeatureFlagsWithDefaults.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Flag's default value
     */
    opgn_2504_a_test_flag: boolean = false;

}
